<template>
	<div class="dropdown">
		<button class="btn btn-default dropdown-toggle btn-action" :id="id" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
			Action
			<span class="fa-stack">
				<i class="fa fa-caret-down fa-stack-1x"></i>
			</span>
		</button>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		id: {
			type: String,
			required: true,
		},
	}
}
</script>